import { SvgIcon } from '@mui/material';

export default function Cone(): JSX.Element {
  return (
    <SvgIcon fontSize="small">
      <svg
        height="100px"
        width="100px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <path
          style={{ fill: '#FF9B46' }}
          d="M94.815,474.074L216.229,7.096C217.316,2.917,221.088,0,225.406,0h61.189
	c4.318,0,8.09,2.917,9.177,7.096l121.414,466.978"
        />
        <g>
          <path
            style={{ fill: '#FF823C' }}
            d="M248.801,0h-23.396c-4.318,0-8.09,2.917-9.177,7.096L94.815,474.074h123.259L246.642,7.096
		C246.898,2.917,247.785,0,248.801,0z"
          />
          <path
            style={{ fill: '#FF823C' }}
            d="M464.593,474.074H47.407c-5.236,0-9.481,4.245-9.481,9.482v18.963c0,5.236,4.245,9.481,9.481,9.481
		h417.185c5.236,0,9.481-4.245,9.481-9.481v-18.963C474.074,478.318,469.829,474.074,464.593,474.074z"
          />
        </g>
        <path
          style={{ fill: '#F56E2D' }}
          d="M199.111,502.519v-18.963c0-5.236,4.245-9.482,9.481-9.482H47.407c-5.236,0-9.481,4.245-9.481,9.482
	v18.963c0,5.236,4.245,9.481,9.481,9.481h161.185C203.355,512,199.111,507.755,199.111,502.519z"
        />
        <g>
          <polygon
            style={{ fill: '#E4EAF8' }}
            points="119.467,379.259 392.533,379.259 377.742,322.37 134.258,322.37 	"
          />
          <polygon
            style={{ fill: '#E4EAF8' }}
            points="168.77,189.63 343.23,189.63 328.439,132.741 183.561,132.741 	"
          />
        </g>
        <g>
          <polygon
            style={{ fill: '#C7CFE2' }}
            points="168.77,189.63 235.475,189.63 238.956,132.741 183.561,132.741 	"
          />
          <polygon
            style={{ fill: '#C7CFE2' }}
            points="119.467,379.259 223.874,379.259 227.354,322.37 134.258,322.37 	"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
